export * from './getProductDetailInfo';
